import { Container } from './Container'
import { IconCheckCircle } from './Icon'

type Props = {
	isChecked: boolean
}

export const CheckCircle = ({ isChecked }: Props) => (
	<Container isChecked={isChecked}>{isChecked && <IconCheckCircle />}</Container>
)
